import { render, staticRenderFns } from "./IconHit.vue?vue&type=template&id=3d287170&"
import script from "./IconHit.vue?vue&type=script&lang=js&"
export * from "./IconHit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports